var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.0505 0.421875H6.9588C3.31188 0.421875 0.355469 3.37829 0.355469 7.02521V14.9702C0.355469 18.6171 3.31188 21.5735 6.9588 21.5735H17.0505C20.6974 21.5735 23.6538 18.6171 23.6538 14.9702V7.02521C23.6538 3.37829 20.6974 0.421875 17.0505 0.421875Z",
    fill: "#F7A703"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56664 10.9418C9.22902 10.9418 10.5766 9.58892 10.5766 7.9201C10.5766 6.25128 9.22902 4.89844 7.56664 4.89844C5.90426 4.89844 4.55664 6.25128 4.55664 7.9201C4.55664 9.58892 5.90426 10.9418 7.56664 10.9418Z",
    fill: "#F7A703"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56604 17.63C10.0274 17.63 12.0227 16.3137 12.0227 14.69C12.0227 13.0663 10.0274 11.75 7.56604 11.75C5.10469 11.75 3.10938 13.0663 3.10938 14.69C3.10938 16.3137 5.10469 17.63 7.56604 17.63Z",
    fill: "#F7A703"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6047 14.3828H15.498C15.266 14.3828 15.0434 14.2906 14.8793 14.1265C14.7152 13.9624 14.623 13.7399 14.623 13.5078C14.623 13.2757 14.7152 13.0532 14.8793 12.8891C15.0434 12.725 15.266 12.6328 15.498 12.6328H19.5697C19.8018 12.6328 20.0243 12.725 20.1884 12.8891C20.3525 13.0532 20.4447 13.2757 20.4447 13.5078C20.4447 13.7399 20.3525 13.9624 20.1884 14.1265C20.0243 14.2906 19.8018 14.3828 19.5697 14.3828H19.6047Z",
    fill: "#F7A703"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0506 9.90625H13.8906C13.6586 9.90625 13.436 9.81406 13.2719 9.64997C13.1078 9.48587 13.0156 9.26331 13.0156 9.03125C13.0156 8.79919 13.1078 8.57663 13.2719 8.41253C13.436 8.24844 13.6586 8.15625 13.8906 8.15625H20.0506C20.2827 8.15625 20.5052 8.24844 20.6693 8.41253C20.8334 8.57663 20.9256 8.79919 20.9256 9.03125C20.9256 9.26331 20.8334 9.48587 20.6693 9.64997C20.5052 9.81406 20.2827 9.90625 20.0506 9.90625V9.90625Z",
    fill: "#F7A703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.1697cd32b7677625b1103a16addc997c.svg";
export { ForwardRef as ReactComponent };